export default "__VITE_ASSET__CHIULmT7__"